import {useNavigate, useRouteError} from "react-router-dom";
import styled from "styled-components";
import {colors} from "../common/colors";
import Button from "../components/common/Button";
import {routes} from "../common/routes";

export default function ErrorPage() {
  const error = useRouteError() as {statusText?:string, message?:string};
  const navigate = useNavigate();
  return (
    <Container>
      <p>
        <i>{error?.statusText || error?.message}</i>
      </p>
      <div>잠시 후 다시 시도해주세요.</div>
      <div>문제가 지속되는 경우 contact@projectwith.io 으로 문의해주세요.</div>
      <div className="button-wrapper">
        <Button text={"홈으로 이동"} className="default" onClick={() => navigate(`/${routes.baseUrl}`)} />
      </div>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: ${colors.darkBlue};
  color: #FFF;
  
  p {
    font-weight: 700;
    font-size: 24px;
    margin-bottom: 20px;
  }
  div {
    font-size: 16px;
    margin-bottom: 12px;
    &.button-wrapper {
      position: relative;
      width: 120px;
      height: 40px;
      button {
        background-color: ${colors.button.blue};
        border-radius: 6px;
        color: #FFF;
        cursor: pointer;
      }
    }
  }
`